function Paste({ size }: { size: number }) {
  return (
    <svg height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 12.0005H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 15.0005H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 3.75049H18.75C18.9489 3.75049 19.1397 3.82951 19.2803 3.97016C19.421 4.11081 19.5 4.30158 19.5 4.50049V18.7505C19.5 19.3472 19.2629 19.9195 18.841 20.3415C18.419 20.7634 17.8467 21.0005 17.25 21.0005H6.75C6.15326 21.0005 5.58097 20.7634 5.15901 20.3415C4.73705 19.9195 4.5 19.3472 4.5 18.7505V4.50049C4.5 4.30158 4.57902 4.11081 4.71967 3.97016C4.86032 3.82951 5.05109 3.75049 5.25 3.75049Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 2.25049V5.25049"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 2.25049V5.25049"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 2.25049V5.25049"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Paste
